import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_ARTICLE_SCHEMA_LITERAL = {
    title: 'Schéma Articles',
    description: 'Décrit un article',
    version: 5,
    keyCompression: false,
    primaryKey: 'AR_REF',
    type: 'object',
    properties: {
        AR_REF: { type: 'string', default: '', maxLength: 20 },
        AR_DESIGN: { type: 'string', default: '', maxLength: 70 },
        FA_FAMNV1: { type: 'string' },
        FA_FAMNV1LIB: { type: 'string' },
        FA_FAMNV2: { type: 'string' },
        FA_FAMNV2LIB: { type: 'string' },
        AR_SUIVISTOCKLIB : { type: 'string' },
        AR_TYPELIB: { type: 'string' },
        AR_NOMENCLLIB: { type: 'string' },
        AR_GAMME1: { type: 'number' },
        AR_GAMME1LIB: { type: 'string' },
        AR_GAMME2: { type: 'number' },
        AR_GAMME2LIB: { type: 'string' },
        AR_CAT1LIB: { type: 'string' },
        AR_CAT2LIB: { type: 'string' },
        AR_CAT3LIB: { type: 'string' },
        AR_CAT4LIB: { type: 'string' },
        AR_CONDITION: { type: 'number' },
        AR_CONDITIONLIB: { type: 'string' },
        AR_PRIXVEN: { type: 'number' },  // , maximum: 100, default: 100
        AR_PRIXTTCLIB: { type: 'string' },
        AR_UNITEVEN: { type: 'string' },
        AR_CODEBARRE: { type: 'string' },
        AR_FACTPOIDS: { type: 'number' },
        AR_POIDSNET: { type: 'number' },
        AR_POIDSBRUT: { type: 'number' },
        AR_NOTIMP: { type: 'boolean' },
        IS_HGLT: { type: 'boolean' },
        HGLT_DESIGN: { type: ['string', 'null'] },
        HGLT_COLOR: { type: ['string', 'null'] },
        HGLT_ICON_BACKGROUND_COLOR: { type: ['string', 'null'] },
        HGLT_ICON_COLOR: { type: ['string', 'null'] },
        HGLT_ICON: { type: ['string', 'null'] },
        HGLT_BACKGROUND_COLOR: { type: ['string', 'null'] },
        HGLT_CSTM_CATEGORIE: { type: ['string', 'null'] },
        HGLT_CSTM_SOUSCATEGORIE: { type: ['string', 'null'] },
        HGLT_IS_IMG: { type: 'boolean' },
        HGLT_IMG_DATA: { type: ['string', 'null'] },
        ARTSTOCK_TOT: { type: 'number' },
        ARTVTECLU_TOT: { type: 'number' },
        STOCKESTIME_TOT: { type: 'number' },
        ARTSTOCK_ITEMS_JSON: { type: ['string', 'null'] },
        ARTVTECLU_ITEMS_JSON: { type: ['string', 'null'] },
        EXTRA: { type: ['string', 'null'] }
    },
    required: [ 'AR_REF', 'AR_DESIGN', 'AR_PRIXVEN', 'AR_CONDITION', 'AR_TYPELIB', 'AR_NOMENCLLIB'] 
} as const;

const schemaTyped = toTypedRxJsonSchema(F_ARTICLE_SCHEMA_LITERAL);
export type RxFArticleDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_ARTICLE_SCHEMA: RxJsonSchema<RxFArticleDocumentType> = F_ARTICLE_SCHEMA_LITERAL;
